import React, { Component } from "react";
import Menu from "./Menu";

class MenuToggle extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      toggled: false,
    };
  }

  toggle = () => {
    this.setState((prev) => ({ toggled: !prev.toggled }));
  };

  handleOnChange = (value) => {
    this.setState({
      toggled: value,
    });
  };

  render() {
    const { toggled } = this.state;

    if (toggled) {
      return <Menu />;
    }

    return null;
  }
}

export default MenuToggle;
